rdefine('app/formular/models/FormularModel',['backbone'],function(Backbone){
    return Backbone.Ribs.Model.extend({
        defaults:{
            notify_admin:false,
            notify_custom:false,
            custom_email:'',
            assigned:false
        }
    });
});